import React, { useEffect, useState } from "react";
import api from "./api";
import { CLAIM_STORAGE_KEY } from "./landingDemoModel";
import "./LandingDemo.css";

function DemoTaskImportPrompt() {
  const [claimCode, setClaimCode] = useState("");
  const [repos, setRepos] = useState([]);
  const [repoId, setRepoId] = useState("");
  const [status, setStatus] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    try {
      const stored = sessionStorage.getItem(CLAIM_STORAGE_KEY) || "";
      setClaimCode(stored);
    } catch {
      setClaimCode("");
    }
  }, []);

  useEffect(() => {
    if (!claimCode) return undefined;
    let cancelled = false;
    (async () => {
      try {
        const response = await api.get("/users/profile");
        if (cancelled) return;
        const nextRepos = response.data.repos || [];
        setRepos(nextRepos);
        if (nextRepos[0]?._id) setRepoId(String(nextRepos[0]._id));
      } catch {
        if (!cancelled) setError("Connect a repository to keep the preview Task.");
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [claimCode]);

  if (!claimCode) return null;

  const dismiss = () => {
    try {
      sessionStorage.removeItem(CLAIM_STORAGE_KEY);
    } catch {
      /* ignore */
    }
    setClaimCode("");
  };

  const importTask = async () => {
    if (!repoId) {
      setError("Choose a repository to keep this Task.");
      return;
    }
    setBusy(true);
    setError("");
    try {
      await api.importPublicDemo({ claimCode, repoId });
      sessionStorage.removeItem(CLAIM_STORAGE_KEY);
      setStatus("The preview Task is now in this repository.");
      setClaimCode("");
    } catch (err) {
      const message =
        err.response?.data?.error ||
        "That preview could not be imported. You can still create a Task after you connect a repository.";
      setError(message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <section className="demo-import-prompt" data-testid="demo-import-prompt" aria-labelledby="demo-import-title">
      <h2 id="demo-import-title">Keep the Task from your preview?</h2>
      <p>Confirm importing the preview Task into one of your repositories. The code is used once and then discarded.</p>
      {repos.length ? (
        <label>
          Repository
          <select value={repoId} onChange={(event) => setRepoId(event.target.value)}>
            {repos.map((repo) => (
              <option key={repo._id} value={repo._id}>
                {repo.name || repo._id}
              </option>
            ))}
          </select>
        </label>
      ) : (
        <p>Connect a repository first. The preview code will not be used until you confirm.</p>
      )}
      {error ? (
        <p className="landing-demo-error" role="alert">
          {error}
        </p>
      ) : null}
      {status ? <p role="status">{status}</p> : null}
      <div className="landing-demo-actions">
        <button type="button" className="landing-demo-send" onClick={importTask} disabled={busy || !repoId}>
          Import this Task
        </button>
        <button type="button" className="landing-demo-secondary" onClick={dismiss}>
          Not now
        </button>
      </div>
    </section>
  );
}

export default DemoTaskImportPrompt;
